module.exports = __webpack_public_path__ + "static/eshop3-7d45f105f13b781b61fa9a85aa1cd57c.gif";